import inputs from "../../../../../components/inputs/inputConfigs/fee";

export default timezone => ({
  groups: [
    {
      items: [
        {
          input: {
            ...inputs.feeBillDate,
            timezone,
          },
          grid: { xs: 6 },
        },
        {
          input: inputs.feeInvoiceReferenceNumber,
          grid: { xs: 6 },
        },
      ],
    },
  ],
});
